<template>
  <div class="product-service" v-if="load">
    <div class="banner">
      <img :src="banner.cover" alt />
    </div>
    <!-- 2 -->
    <div id="product1">
      <div id="block-storyrun" class="block__wrapper" style="display: block;">
        <article role="article" class="clearfix news-run-wide news-run row collapse crop-middle">
          <div class="columns small-12 large-7 xlarge-8 xxlarge-8 xxxlarge-8" aria-hidden="true">
            <div
              class="field field--name-field-news-cover-image field--type-entity-reference field--label-hidden field__item"
            >
              <article class="view-mode-captionless-medium media media-image">
                <div
                  class="field field--name-image field--type-image field--label-hidden field__item"
                >
                  <img :src="type1.list[0].cover" alt typeof="foaf:Image" />
                </div>
              </article>
            </div>
          </div>
          <div class="columns small-12 large-5 xlarge-4 xxlarge-4 xxxlarge-4">
            <div class="content row collapse">
              <div class="news-category">
                <a href="javascript:;">{{type1.name}}</a>
              </div>
              <a :href="`/productDetails?id=${type1.list[0].id}`" class="padme">
                <div class="columns small-12 medium-12 large-12 xlarge-12 xxlarge-12 xxxlarge-12">
                  <h2>
                    <span>{{type1.list[0].title}}</span>
                    <span class="show-for-sr">.</span>
                  </h2>
                </div>
                <div class="columns small-12 medium-12 large-12 xlarge-12 xxlarge-12 xxxlarge-12">
                  <p>{{type1.list[0].brief}}</p>
                  <div class="readmore" aria-hidden="true">查看全文</div>
                </div>
              </a>
            </div>
          </div>
        </article>
      </div>
    </div>
    <!-- 4 -->
    <div
      id="product2"
      class="paragraph clearfix paragraph--type--paragraph-view paragraph--view-mode--default"
    >
      <div
        class="field field--name-field-paragraph-block field--type-block-field field--label-hidden field__items"
      >
        <div class="field__item">
          <div class="news-run">
            <article
              role="article"
              about
              class="clearfix news-run-wide news-run row collapse crop-top"
            >
              <div
                class="columns small-12 large-7 xlarge-8 xxlarge-8 xxxlarge-8"
                aria-hidden="true"
              >
                <div
                  class="field field--name-field-news-cover-image field--type-entity-reference field--label-hidden field__item"
                >
                  <article class="view-mode-captionless-medium media media-image">
                    <div
                      class="field field--name-image field--type-image field--label-hidden field__item"
                    >
                      <img
                        sizes="(min-width:40em) 50vw, 100vw"
                        :src="type2.list[0].cover"
                        alt
                        typeof="foaf:Image"
                      />
                    </div>
                  </article>
                </div>
              </div>
              <div class="columns small-12 large-5 xlarge-4 xxlarge-4 xxxlarge-4">
                <div class="content row collapse">
                  <div class="news-category">
                    <a href="javascript:;">{{type2.name}}</a>
                  </div>
                  <a :href="`/productDetails?id=${type2.list[0].id}`" class="padme">
                    <div
                      class="columns small-12 medium-12 large-12 xlarge-12 xxlarge-12 xxxlarge-12"
                    >
                      <h2>
                        <span>{{type2.list[0].title}}</span>
                        <span class="show-for-sr">.</span>
                      </h2>
                    </div>
                    <div
                      class="columns small-12 medium-12 large-12 xlarge-12 xxlarge-12 xxxlarge-12"
                    >
                      <p>{{type2.list[0].brief}}</p>
                      <div class="readmore" aria-hidden="true">查看全文</div>
                    </div>
                  </a>
                </div>
              </div>
            </article>
          </div>
        </div>
      </div>
    </div>
    <!-- 4 -->
    <div id="product3">
      <div id="block-storyrun" class="block__wrapper" style="display: block;">
        <article role="article" class="clearfix news-run-wide news-run row collapse crop-middle">
          <div class="columns small-12 large-7 xlarge-8 xxlarge-8 xxxlarge-8" aria-hidden="true">
            <div
              class="field field--name-field-news-cover-image field--type-entity-reference field--label-hidden field__item"
            >
              <article class="view-mode-captionless-medium media media-image">
                <div
                  class="field field--name-image field--type-image field--label-hidden field__item"
                >
                  <img
                    sizes="(min-width:40em) 50vw, 100vw"
                    :src="type3.list[0].cover"
                    alt
                    typeof="foaf:Image"
                  />
                </div>
              </article>
            </div>
          </div>
          <div class="columns small-12 large-5 xlarge-4 xxlarge-4 xxxlarge-4">
            <div class="content row collapse">
              <div class="news-category">
                <a href="javascript:;">{{type3.name}}</a>
              </div>

              <a :href="`/productDetails?id=${type3.list[0].id}`" class="padme">
                <div class="columns small-12 medium-12 large-12 xxlarge-12 xxxlarge-12">
                  <h2>
                    <span>{{type3.list[0].title}}</span>
                    <span class="show-for-sr">.</span>
                  </h2>
                </div>
                <div class="columns small-12 medium-12 large-12 xxlarge-12 xxxlarge-12">
                  <p>{{type3.list[0].brief}}</p>
                  <div class="readmore" aria-hidden="true">查看全文</div>
                </div>
              </a>
            </div>
          </div>
        </article>
      </div>
    </div>
    <!-- 6 -->
    <div
      id="product4"
      class="paragraph clearfix paragraph--type--paragraph-view paragraph--view-mode--default"
    >
      <div
        class="field field--name-field-paragraph-block field--type-block-field field--label-hidden field__items"
      >
        <div class="field__item">
          <div class="news-run">
            <article
              role="article"
              about
              class="clearfix news-run-wide news-run row collapse crop-top"
            >
              <div
                class="columns small-12 large-7 xlarge-8 xxlarge-8 xxxlarge-8"
                aria-hidden="true"
              >
                <div
                  class="field field--name-field-news-cover-image field--type-entity-reference field--label-hidden field__item"
                >
                  <article class="view-mode-captionless-medium media media-image">
                    <div
                      class="field field--name-image field--type-image field--label-hidden field__item"
                    >
                      <img :src="type4.list[0].cover" alt typeof="foaf:Image" />
                    </div>
                  </article>
                </div>
              </div>
              <div class="columns small-12 large-5 xlarge-4 xxlarge-4 xxxlarge-4">
                <div class="content row collapse">
                  <div class="news-category">
                    <a href="javascript:;">{{type4.name}}</a>
                  </div>
                  <a :href="`/productDetails?id=${type4.list[0].id}`" class="padme">
                    <div
                      class="columns small-12 medium-12 large-12 xxlarge-12 xxlarge-12 xxxlarge-12"
                    >
                      <h2>
                        <span>{{type4.list[0].title}}</span>
                        <span class="show-for-sr">.</span>
                      </h2>
                    </div>
                    <div
                      class="columns small-12 medium-12 large-12 xxlarge-12 xxlarge-12 xxxlarge-12"
                    >
                      <p>{{type4.list[0].brief}}</p>
                      <div class="readmore" aria-hidden="true">查看全文</div>
                    </div>
                  </a>
                </div>
              </div>
            </article>
          </div>
        </div>
      </div>
    </div>
    <!-- 7 -->
    <!-- 1 -->
    <div
      id="product5"
      class="content-tile-set content-tile-cards columns-4 paragraph clearfix constrain paragraph--type--tileset paragraph--view-mode--default"
      style="background: #000"
    >
      <div
        class="content-tile-set-item card"
        data-equalizer-watch
        v-for="(item,index) in type5.list"
        :key="index"
      >
        <div class="content-tile content-tile-flashcard flashcard flashcard-default">
          <a :href="`/productDetails?id=${item.id}`">
            <div aria-hidden="true">
              <article class="view-mode-tile-small media media-image">
                <div
                  data-blazy
                  class="blazy blazy--field blazy--image blazy--image--tile-small field field--name-image field--type-image field--label-hidden field__item blazy--on"
                >
                  <div
                    class="media media--bundle--image media--blazy media--responsive media--image"
                  >
                    <img
                      class="media__image media__element b-lazy b-responsive b-loaded"
                      :src="item.cover"
                      alt
                      typeof="foaf:Image"
                    />
                  </div>
                </div>
              </article>
            </div>
            <div class="card-section student-card">
              <div class="news-category">
                <a href="javascript:;">{{type5.name}}</a>
              </div>
              <h3>
                <div
                  class="field field--name-name field--type-string field--label-hidden field__item"
                >{{item.title}}</div>
                <span class="show-for-sr">.</span>
              </h3>
              <div class>
                <p>{{item.brief}}</p>
              </div>

              <div class="readmore" aria-hidden="true">查看全文</div>
            </div>
          </a>
        </div>
      </div>
    </div>

    <!-- 1 -->

    <div
      id="product6"
      class="paragraph clearfix paragraph--type--paragraph-view paragraph--view-mode--default"
    >
      <div
        class="field field--name-field-paragraph-block field--type-block-field field--label-hidden field__items"
      >
        <div class="field__item">
          <div class="news-run block">
            <article
              role="article"
              about
              class="card news-teaser news-teaser-card-summary content-tile-flashcard content-tile-set-item"
              data-equalizer-watch
              v-for="(item,index) in type6.list"
              :key="index"
            >
              <a :href="`/productDetails?id=${item.id}`">
                <div aria-hidden="true">
                  <div
                    class="field field--name-field-news-cover-image field--type-entity-reference field--label-hidden field__item"
                  >
                    <article class="view-mode-tile-small media media-image">
                      <div
                        data-blazy
                        class="blazy blazy--field blazy--image blazy--image--tile-small field field--name-image field--type-image field--label-hidden field__item blazy--on"
                      >
                        <div
                          class="media media--bundle--image media--blazy media--responsive media--image"
                        >
                          <img
                            class="media__image media__element b-lazy b-responsive b-loaded"
                            :src="item.cover"
                            alt
                            typeof="foaf:Image"
                          />
                        </div>
                      </div>
                    </article>
                  </div>
                </div>
                <div class="card-section footer-card">
                  <div class="news-category">
                    <a href="javascript:;">{{type6.name}}</a>
                  </div>
                  <h3>
                    <span>{{item.title}}</span>
                    <span class="show-for-sr">.</span>
                  </h3>

                  <div class="show-for-large">
                    <p>{{item.brief}}</p>
                  </div>
                  <div class="readmore" aria-hidden="true">查看全文</div>
                </div>
              </a>
            </article>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ProductList } from "@/api/index";
export default {
  components: {},
  data() {
    return {
      load: false,
      banner: null,
      type1: null,
      type2: null,
      type3: null,
      type4: null,
      type5: null,
      type6: null,
    };
  },
  computed: {},
  watch: {},
  methods: {},
  created() {
    ProductList((res) => {
      this.load = true;
      this.$emit("complete", true);
      if (res.code == 0) {
        this.banner = res.data.banner;
        this.type1 = res.data.list.find((item) => item.type === 1);
        this.type2 = res.data.list.find((item) => item.type === 2);
        this.type3 = res.data.list.find((item) => item.type === 3);
        this.type4 = res.data.list.find((item) => item.type === 4);
        this.type5 = res.data.list.find((item) => item.type === 5);
        this.type6 = res.data.list.find((item) => item.type === 6);

        setTimeout(() => {
          window.SynchronousMaxHeight("student-card");
          window.SynchronousMaxHeight("footer-card");
          window.SynchronousMinHeight("media__image", "media--image");
        }, 101);
      }
    });
  },
  mounted() {
    document.getElementById("productTab").classList.add("is-active");
    window.onresize = function () {
      window.SynchronousMaxHeight("student-card");
      window.SynchronousMaxHeight("footer-card");
      window.SynchronousMinHeight("media__image", "media--image");
    };
  },
};
</script>
<style lang='less' scoped>
.content-tile img {
  margin: 0;
}
.media--image {
  overflow: hidden;
}
.banner {
  width: 100%;
  img {
    width: 100%;
  }
}

@media print, screen and (max-width: 40em) {
  .news-category {
    display: none;
  }
  .content-tile-cards {
    padding: 0.9rem;
    .readmore {
      display: none;
    }
  }
  .card {
    border: 0;
  }
  .card-section {
    box-shadow: none;
  }
}
@media screen and (min-width: 120em) {
  #product1 > div,
  #product3 > div {
    width: 100%;
    .xxxlarge-8 {
      float: right;
    }
    .news-category {
      font-size: 1.2rem;
    }
    p {
      font-size: 1.2rem;
    }
  }
  #product2,
  #product4 {
    width: 100%;
    max-width: 100%;
    padding-top: 0;
    .news-category {
      font-size: 1.2rem;
    }
    p {
      font-size: 1.2rem;
    }
  }
}
</style>